export const locale = {
    lang: 'en',
    data: {
        LIST_WHERE_TO_PLACE: 'In which list would you like to place these cards?',
        LIST_ACTIVITY: 'List',
        CANCEL: 'Cancel',
        SAVE: 'Save',
    }
};
